import { LoginInfoState } from '@/config/initialState';
import { store } from '@/config/store';
import { Car, CustomerInfoApiResponse } from '@/types/api/customerApi';
import {
  findRelevantNextWarranty,
  getPreferredCurrentWarranty,
} from '@/utils/warranty';

type StoreStateUpdate<StateName extends string> = StateName extends 'loginInfo'
  ? Partial<LoginInfoState>
  : unknown;

export const storeDispatch = async <StateName extends string>(
  actions: string,
  stateName: StateName,
  newState: StoreStateUpdate<StateName>,
) => {
  await store.dispatch(actions, {
    [stateName]: newState,
  });
};

export const dispatchBasicInfo = async (
  customerInfo: CustomerInfoApiResponse['data'],
  findFnc?: (value: Car) => unknown,
) => {
  const {
    customer,
    cars,
    bill_infomations,
    payment_methods,
    prepaids,
    informations,
    campaigns,
  } = customerInfo;
  const promises = [
    storeDispatch('setCustomerInfo', 'customerInfo', customer),
    storeDispatch('setCarsInfo', 'carsInfo', cars),
    storeDispatch('setBillsInfo', 'billsInfo', bill_infomations),
    storeDispatch(
      'setPaymentMethodsInfo',
      'paymentMethodsInfo',
      payment_methods,
    ),
    storeDispatch('setAdvancePaymentsInfo', 'advancePaymentsInfo', prepaids),
    storeDispatch('setNotificationsInfo', 'notificationsInfo', informations),
    storeDispatch('setCampaignsInfo', 'campaignsInfo', campaigns),
  ];
  if (cars?.length) {
    const car = (findFnc ? cars.find(findFnc) : cars[0]) || cars[0];
    const preferredWarranty = getPreferredCurrentWarranty(car.warranties);
    promises.push(storeDispatch('setCarItemInfo', 'carItemInfo', car));
    if (car?.warranties?.length) {
      promises.push(
        storeDispatch('setWarranties', 'warranties', car.warranties),
      );
      promises.push(
        storeDispatch(
          'setCurrentWarranty',
          'currentWarranty',
          preferredWarranty,
        ),
      );
    }
    if (car.next_warranty?.length) {
      promises.push(
        storeDispatch('setNextWarranties', 'nextWarranties', car.next_warranty),
      );
      promises.push(
        storeDispatch(
          'setNextWarranty',
          'nextWarranty',
          findRelevantNextWarranty(preferredWarranty, car.next_warranty),
        ),
      );
    }
  }
  await Promise.all(promises);
};
